<template>
    <div v-if="!loading">
        <div v-if="$can('user-create')" class="row">
            <div class="col text-right mb-2">
                <b-button class="mr-sm-1 mr-md-1" :href="$routes.route('register')"><i class="far fa-fw fa-plus"></i> Create</b-button>
                <b-button class="mr-sm-1 mr-md-1" @click="findMember"><i class="far fa-fw fa-user"></i> Find Member</b-button>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col-lg col-md-12 mx-sm-1 ml-lg-2 mr-lg-1 mb-md-0 mb-lg-2">
                <b-card class="mb-md-2 mb-lg-0">
                    <b-card-title title-tag="h5" title="Users"></b-card-title>
                    <b-card-body class="px-0">
                        <table class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th class="col-4">Name</th>
                                    <th class="col-2">Email</th>
                                    <th class="col-2">Level</th>
                                    <th class="col-3">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in users" :key="user.id">
                                    <td class="col-4">{{ user.name }}</td>
                                    <td class="col-2">{{ user.email }}</td>
                                    <td class="col-2">{{ user.level }}</td>
                                    <td class="col-3">
                                        <b-button v-if="$can('user-update')" type="button" :href="$routes.route('user.edit', {'user': user.id})" class="btn btn-primary"> <i class="fas fa-fw fa-edit"></i>Edit</b-button>
                                        <button v-if="$can('user-delete')" class="btn btn-danger" @click="deleteUser(user)"><i class="fas fa-fw fa-trash-alt"></i> Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-body>
                </b-card>
            </div>
        </div>

        <b-modal id="findMember" title="Find Member" size="xl" centered no-stacking v-if="showFind" @hidden="destroyFind" scrollable visible>
        <input class="form-control mb-2" type="search" id="memberSearch" placeholder="Member Search..." v-model="memberSearchQuery" />
        <div id="member-table" ref="memberTable"></div>
        <template #modal-footer="{  }"><div></div></template>
    </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            users: [],
            loading: true,
            modal: modal,
            user: {
                name: '',
                email: '',
                level: '',
            },
            showFind: false,
            memberSearchQuery: '',
            members: false,
            memberTabler: null,
        }
    },
    watch: {
        memberSearchQuery: function (val) {
            if (val.length > 2) {
                this.findMembers();
            }
        }
    },
    methods: {
        findMember() {
            this.showFind = true;
        },
        destroyFind() {
            this.showFind = false;
            this.memberSearchQuery = '';
            this.members = [];
            this.memberTabler.destroy();
        },
        fetchUsers() {
            axios.get(this.$routes.route('user.index'))
                .then(response => {
                    this.users = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        deleteUser(user) {
            this.modal.confirm(() => {
                axios.delete(this.$routes.route('user.destroy', {'user': user.id}))
                    .then(response => {
                        this.fetchUsers();
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }, () => {});
        },
        findMembers() {
            axios.get(this.$routes.route('member.index', {'getData': true, 'full': true, 'search': this.memberSearchQuery}))
                .then(response => {
                    this.members = response.data.data;
                    if ( ! this.memberTabler) {
                        this.memberTabler = new Tabulator(this.$refs.memberTable, {
                            data: this.members,
                            layout: 'fitColumns',
                            columns: [
                                {title: 'Name', field: 'name', width: 200},
                                {title: 'Email', field: 'email', width: 200},
                            ],
                            rowClick: (e, row) => {
                                let data = row.getData();
                                axios.post(this.$routes.route('user.create.member', {'member_id':data.id }))
                                    .then(response => {
                                        this.fetchUsers();
                                        this.destroyFind();

                                        // Reload the page
                                        window.location.reload();
                                    })
                                    .catch(error => {
                                        console.log(error);
                                    });
                            },
                        });
                    } else {
                        this.memberTabler.replaceData(this.members);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.loading = true;
        this.fetchUsers();
    },
}
</script>